import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, { className: 'notification' });

export class Notification {
  static _getMergedOptions(options = {}) {
    const defaultClassName = 'notification notification--bare';

    const mergedOptions = {
      className: defaultClassName,
      message: 'Procedimento realizado com sucesso!',
      theme: null,
      position: 'top-center',
      duration: null,
      hasOverlay: false,
      fullWidth: true,
      ...options,
    };

    mergedOptions.className = options.className
      ? ('notification ' + options.className)
      : defaultClassName;

    if (mergedOptions.hasOverlay) {
      mergedOptions.className = mergedOptions.className + ' notification--overlayed';
    }

    return mergedOptions;
  }

  static _getActionConfig(overlayed) {
    const actionConfig = {
      text: '',
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    };

    if (overlayed) {
      return false;
    }

    return actionConfig;
  }

  static _toggleOverlay(overlayed) {
    const notificationContainer = document.getElementsByClassName('toasted-container')[0];

    if (overlayed) {
      notificationContainer.classList.add('notification-overlay');
    } else {
      notificationContainer.classList.remove('notification-overlay');
    }
  }

  static _setOverlayBehaviour(overlayed) {
    const notificationContainer = document.getElementsByClassName('toasted-container')[0];
    let hasNotificationOverlayed = false;

    for (const notification of notificationContainer.children) {
      for (const className of notification.classList) {
        const notificationHasOverlayedClass = className === 'notification--overlayed';

        if (notificationHasOverlayedClass) {
          hasNotificationOverlayed = notificationHasOverlayedClass;
        }
      }
    }

    if (hasNotificationOverlayed || overlayed) {
      Notification._toggleOverlay(true);
    }
  }

  static _showToaster(options = { }) {
    const params = Notification._getMergedOptions(options);

    Vue.toasted.show(`<span>${params.message}</span>`, {
      theme: params.theme,
      position: params.position,
      duration: params.duration,
      className: params.className,
      closeOnSwipe: params.closeOnSwipe,
      action: Notification._getActionConfig(params.hasOverlay),
    });

    Notification._setOverlayBehaviour(params.hasOverlay);
  }

  static clearAll() {
    Vue.toasted.clear();

    Notification._toggleOverlay(false);
  }

  static show(options = { }) {
    const params = {
      message: 'Procedimento realizado com sucesso!',
      ...options,
    };

    Notification._showToaster(params);
  }

  static info(options = { }) {
    const params = {
      className: 'notification--info',
      message: 'Procedimento realizado com sucesso!',
      ...options,
    };

    Notification._showToaster(params);
  }

  static success(options = { }) {
    const params = {
      className: 'notification--success',
      message: 'Procedimento realizado com sucesso!',
      ...options,
    };

    Notification._showToaster(params);
  }

  static error(options = { }) {
    const params = {
      className: 'notification--error',
      message: 'Houve falha ao processar os dados. Por favor tente novamente em instantes.',
      ...options,
    };

    Notification._showToaster(params);
  }
}
